import Loader from "react-loader-spinner";
import { Table, Modal, Button } from 'react-bootstrap';
import { Search, X } from 'react-bootstrap-icons';
import { useDispatch, useSelector } from "react-redux";
import { getCostCenterList } from '../store/api/GetAllProduct';
import { useRef, useState } from "react";
import { setSelectCostCenterPopup } from "../store/api/Modals";
const ModalSelectCostCenter = () => {
    const searchName = useRef();
    const selectedItem = useRef({});
    const costCenterList = useSelector(state => state.ProductReducer.costCenterList?.Data)
    const pop = useSelector(state => state.popup.popSelectCostCenter);
    const { show, onSelect } = pop;
    const dispatch = useDispatch();

    const search = () => {
        dispatch(getCostCenterList(searchName.current.value));
    }
    const close = () => {
        dispatch(setSelectCostCenterPopup({ show: false }));
    }
    const select = () => {
        if (onSelect) {
            onSelect(selectedItem.current);
        }
        dispatch(setSelectCostCenterPopup({ show: false }));
    }
    const setSelectedItem = (item) => {
        selectedItem.current = item;
    }
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#e40375' }}>انتخاب مرکز هزینه<span onClick={close} style={{ cursor: "pointer" }}><X size={20} /></span></Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    <input type="text" className="form-control" ref={searchName} style={{ width: "80%", display: "inline-block" }} placeholder="نام مرکز هزینه" />
                    <Button className="group-Btn-smalll" onClick={search}><Search size={18} /></Button>
                </div>
                <Table responsive className="mt-2 fixedTable">
                    <thead>
                        <tr>
                            <th style={{width:"20%"}}>کد مرکز </th>
                            <th style={{width:"80%"}} scope="col" className="col-3">نام مرکز </th>
                        </tr>
                    </thead>
                    <tbody>
                        {(costCenterList && costCenterList === "PENDING") &&
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center" }}>
                                    <Loader type="BallTriangle" color="rgb(228, 3, 117)" height={20} width={20} />
                                </td>
                            </tr>
                        }
                        {costCenterList && Array.isArray(costCenterList) &&
                            costCenterList.map((item, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => setSelectedItem(item)}>
                                    <td  style={{width:"20%"}}>{item.CenterCode}</td>
                                    <td   style={{width:"80%"}}>{item.CenterName}</td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
                <Button className="group-Btn" onClick={select}>انتخاب</Button>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectCostCenter;